import { Helmet } from "react-helmet-async";
import PageHeader from "./PageHeader";
import { Grid } from "@mui/material";
import PageTitleWrapper from "../../components/PageComponents/PageTitleWrapper";
import Transactions from "./Transactions";
import Bills from "./Bills";
import Requests from "./Requests";
import Payments from "./Payments";
import MainAccount from "./MainAccount";
import SecondaryAccounts from "./SecondaryAccounts";
import CryptoOrdersButton from "./CryptoOrdersButton";
import Investments from "./Investments";
import TransactionsStatistics from "./TransactionsStatistics";
import useAuth from "../../hooks/useAuth";
import { useCurrentProject } from "../../contexts/AccountProjectContext";
import AnimatedBlock from "../../components/Common/AnimatedBlock";

function DashboardGeneral() {
  const auth = useAuth();
  const { hasUserCNHS } = useCurrentProject();

  return (
    <>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>

      <Grid
        sx={{
          px: 4,
        }}
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={4}
          >
            <Grid item lg={hasUserCNHS ? 4 : 6} md={4} sm={6} xs={12}>
              <AnimatedBlock>
                <CryptoOrdersButton />
              </AnimatedBlock>
            </Grid>
            <Grid item lg={hasUserCNHS ? 4 : 6} md={4} sm={6} xs={12}>
              <AnimatedBlock>
                <Transactions />
              </AnimatedBlock>
            </Grid>
            {hasUserCNHS && (
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <AnimatedBlock>
                  <MainAccount />
                </AnimatedBlock>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid item lg={12} md={12} xs={12}>
          <AnimatedBlock>
            <TransactionsStatistics />
          </AnimatedBlock>
        </Grid>
      </Grid>
    </>
  );
}

export default DashboardGeneral;
